<template>
  <div :class="['download-modal-tab-content', element.name]">
    <p>{{ element.title }}</p>

    <select
      v-if="element && element.items && element.items.length > 0"
      @change="changeDropDown"
      class="custom-select mb-3"
    >
      <option
        v-for="(item, index) in element.items"
        :key="item.value"
        :value="item.value"
        :selected="selectedValue && item.value === selectedValue.value"
      >
        <span v-if="element.showItemIndex"> {{ index + 1 }}: </span>
        {{ item.name }}
      </option>
    </select>

    <img v-if="imageURL" :src="imageURL" :alt="element.name" class="mb-3" />

    <button
      class="btn btn-white border border-dark w-100 justify-content-start"
      @click="downloadButtonClick"
    >
      <span class="png-icon png-icon-icons-glyph--k-btn-download"></span>
      <span class="ml-2">
        {{ element.downloadBtnText }}
      </span>
    </button>
    <a
      v-if="element.name === 'swatch'"
      id="download-styles"
      download
      class="invisible"
      @click="downloadLinkClick"
      :href="downloadUrl"
      >Download
    </a>
  </div>
</template>

<script>
import PatcraftApi from "../../scripts/patcraft-api";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedValue: null,
      imageURL: null,
      downloadUrl: "",
      backupUrls: []
    };
  },
  props: ["element", "isInstallation", "isRoomScene", "defaultItem"],
  created() {
    this.DEFAULT_IMAGE_SIZE = 300;
    this.selectedValue = this.defaultItem;
    this.setImage(this.DEFAULT_IMAGE_SIZE);
  },
  computed: {
    ...mapGetters({
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      color: "productDetail/color"
    })
  },
  methods: {
    getDownloadURL() {
      let fileURL = this.imageURL?.split("?")[0];
      // let backupUrls = [];

      if (this.element.items.length === 0) {
        if (
          this.color &&
          this.color.downloadTileVariationOverrideURL &&
          this.color.downloadTileVariationOverrideURL.length > 0
        )
          return this.color.downloadTileVariationOverrideURL;
        // If no dropdown items, then download tileset zip
        this.color?.samples?.forEach((sample, index) => {
          sample?.sizes?.forEach(size => {
            let width = size?.width?.imperial?.originalValue;
            let length = size?.length?.imperial?.originalValue;
            let imgUrl = this.$helpers.getTilesetUrl(
              this.sellingStyleNumber,
              this.color.colorNumber,
              width ?? 0,
              length ?? 0
            );
            if (index === 0) {
              fileURL = imgUrl;
            } else {
              this.backupUrls.push(imgUrl);
            }
          });
        });
      } else {
        // Request Tricycle images at maximum size
        fileURL += "?pixels=5100";
      }
      return fileURL;
    },
    downloadLinkClick(el) {
      let link = el.target.getAttribute("href");
      let xhr = new XMLHttpRequest();
      xhr.open("GET", link);
      xhr.send();

      xhr.addEventListener("progress", e => {
        if (e.loaded > 100) {
          xhr.abort();
          this.toggleSpinner();
          return 200;
        }
      });
    },
    async downloadButtonClick() {
      if (this.element.name !== "swatch") {
        let fileName = `${this.sellingStyleNumber}-${this.color.colorNumber}`;
        if (this.selectedValue) fileName += `-${this.selectedValue.name}`;
        await PatcraftApi.downloadImageFile(
          this.downloadUrl,
          fileName,
          this.backupUrls
        );
        return;
      }
      this.toggleSpinner();

      this.loadImage(this.downloadUrl, this.backupUrls);
    },
    displayError() {
      let err = document.querySelector(".modal-error-404");
      this.toggleSpinner();

      err.classList.remove("d-none");

      setTimeout(() => {
        err.classList.add("d-none");
      }, 2000);
    },
    loadImage(url, bkpUrls) {
      if (!url && (!bkpUrls || !bkpUrls.length)) {
        this.displayError();
        return;
      }

      if (!url) {
        this.loadImage(bkpUrls[0], bkpUrls.splice(0, 1));
        return;
      }

      let xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.send();

      xhr.addEventListener("progress", e => {
        if (e.loaded > 100) {
          xhr.abort();
          let link = document.getElementById("download-styles");
          link.setAttribute("href", url);
          link.click();
          return;
        }
      });
      xhr.addEventListener("load", e => {
        if (xhr.status !== 200) {
          if (bkpUrls && bkpUrls.length > 0) {
            let bkpUrl = bkpUrls[0];
            bkpUrls.splice(0, 1);
            this.loadImage(bkpUrl, bkpUrls);
            xhr.abort();
            return;
          } else this.displayError();
        }
      });
    },
    toggleSpinner() {
      let spiner = document.getElementById("wf-download-modal-spiner");
      spiner.classList.toggle("d-none");
    },
    changeDropDown(event) {
      let item = this.element.items.find(
        i => i.value.toString() === event.target.value
      );
      this.initCurrentTabDropDownValue(item);
      this.setImage(this.DEFAULT_IMAGE_SIZE);
    },

    initCurrentTabDropDownValue(item) {
      this.selectedValue = item;
    },

    getColorInstallationImageUrl(size) {
      return this.$helpers.getColorInstallationImageUrl(
        this.sellingStyleNumber,
        this.color.colorNumber,
        this.selectedValue.name,
        size
      );
    },

    getRoomSceneImageURL(size) {
      let isStaticRommScene =
        this.selectedValue &&
        typeof this.selectedValue.value === "string" &&
        this.selectedValue.value.indexOf("http") >= 0;

      if (isStaticRommScene) return this.selectedValue.value;

      return this.$helpers.getInteractiveRoomSceneImageUrl(
        this.sellingStyleNumber,
        this.color.colorNumber,
        this.selectedValue.value,
        this.selectedValue.currentInstallation.name,
        size
      );
    },

    setImage(size) {
      if (this.isInstallation)
        this.imageURL = this.getColorInstallationImageUrl(size);
      if (this.isRoomScene) this.imageURL = this.getRoomSceneImageURL(size);
      this.downloadUrl = this.getDownloadURL();
    }
  }
};
</script>
